let job = {};

job = require('../data/job')

module.exports = job;